import PropTypes from 'prop-types';
import merge from 'lodash/merge';
import ReactApexChart from 'react-apexcharts';
// @mui
import { Card, CardHeader, Box } from '@mui/material';
// components
import { BaseOptionChart } from '../../components/chart';

// ----------------------------------------------------------------------

ReportBarChart.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartData: PropTypes.array.isRequired,
  chartLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default function ReportBarChart({ title, xtittle, ytittle, subheader, chartLabels, chartData, handleSubCategory, ...other }) {
  const chartOptions = merge(BaseOptionChart(), {
    plotOptions: { bar: { columnWidth: '16%', } },
    fill: { type: chartData.map((i) => i.fill) },
    labels: chartLabels,
    yaxis: {
      title: {
        text: ytittle
      },
    },
    xaxis: {
      title: {
        text: xtittle
      },
    },
    // xaxis: { type: 'datetime' },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(0)} `;
          }
          return y;
        },
      },
    },
  });

  // console.log(chartLabels)

  chartOptions.chart.events = {
    dataPointSelection: (event, chartContext, config) => handleSubCategory(chartLabels[config.dataPointIndex])
  }

  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader} />
      <Box dir="ltr">
        <ReactApexChart type="line" series={chartData} options={chartOptions} height={400} />
      </Box>
    </Card>
  );
}
